import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { OrderDetailsService } from '@app/orders/services/order-details.service';
import { Store } from '@ngrx/store';
import * as fromOrders from '@root-store/orders-store/index';
import { filter, map, take } from 'rxjs';

@Component({
  selector: 'app-orders-home',
  templateUrl: './orders-home.component.html',
  styleUrls: ['./orders-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrdersHomeComponent {
  private readonly store = inject<Store<fromOrders.State>>(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly orderDetailsService = inject(OrderDetailsService);
  private readonly destroyRef = inject(DestroyRef);

  readonly isFromCustomers = toSignal(
    this.store.select(fromOrders.selectors.isFromCustomersPage).pipe(map((v) => !v)),
    { initialValue: true },
  );

  constructor() {
    this.route.params
      .pipe(
        filter((params) => params['orderId']),
        take(1),
        takeUntilDestroyed(),
      )
      .subscribe((params) => {
        const orderId = +params['orderId'];
        const orderItemId = params['orderItemId'] ? +params['orderItemId'] : null;
        this.orderDetailsService.open(orderId, orderItemId);
      });

    this.destroyRef.onDestroy(() => {
      this.store.dispatch(fromOrders.actions.resetOrdersListFilters());
    });
  }
}
